module.exports = __webpack_public_path__ + "img/sq5m_04.1720061d.jpg";